import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
const searchSteps = ['You search for ideas.', 'You collect diagrams from different sources.', 'You rebuild explanations you have already taught before.', 'You create another workshop activity.', 'You prepare another assessment.'];
export function PainPoints() {
  return <section className="py-24 px-4 bg-white" data-id="element-152" data-mp="1xxre0on8ddaa">
      <div className="max-w-4xl mx-auto" data-id="element-153" data-mp="1xwyf29uijs2p">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-154" data-mp="1y043dmvbipxd">
          <h2 className="text-3xl md:text-4xl font-display font-bold uppercase mb-6 text-primary" data-id="element-155" data-mp="1szg5qicl3au6">
            Does This Sound Familiar?
          </h2>
          <div className="text-lg text-body leading-relaxed bg-white p-6 rounded-xl border border-primary/15 border-l-4 border-l-accent shadow-sm shadow-primary/5 text-left space-y-4" data-id="element-156" data-mp="3ncfoulg6an67">
            <p data-id="element-157" data-mp="1yyc3nu5x6itq">Another Automotive Technology class is coming.</p>
            <p data-id="element-158" data-mp="1u12dgcapi34u">
              And instead of finishing your day, you are still searching for diagrams, looking for
              technical material, deciding what system to teach, preparing workshop activities,
              building assessments and trying to find a simple way to explain a complicated
              automotive concept.
            </p>
            <p data-id="element-159" data-mp="1b2zmvt2ify4x">
              <span className="text-primary font-semibold" data-id="element-160" data-mp="1b3hrbczbtinx">
                Not because you do not understand Automotive Technology.
              </span>{' '}
              Because knowing Automotive Technology and having a complete structured teaching system
              are two different things.
            </p>
            <p className="text-primary font-semibold" data-id="element-161" data-mp="30gcrljejbo6k">
              Without a system, every lesson starts from zero.
            </p>
            <div className="space-y-1" data-id="element-162" data-mp="2vknox777xr61">
              {searchSteps.map(step => <p key={step} data-id="element-163" data-mp="1t4vl4m7pksrb">{step}</p>)}
            </div>
            <p data-id="element-164" data-mp="1y36qajn26f37">And the time that should belong to you becomes preparation time.</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-165" data-mp="226czo05gwmdw">
          <h3 className="text-xl font-display font-bold uppercase text-primary mb-8 text-center" data-id="element-166" data-mp="1acucis54to4p">
            The Real Cost of Building Every Automotive Lesson From Scratch
          </h3>
          <div className="overflow-hidden rounded-xl border border-primary/15 bg-white shadow-sm shadow-primary/5" data-id="element-167" data-mp="1je0t117s6yxy">
            {painPoints.map((point, index) => <motion.p key={point} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="px-5 py-4 text-body text-sm leading-relaxed border-t first:border-t-0 border-primary/10" data-id="element-168" data-mp="qpn02zvjust9" data-mpi={index}>
                <span className="mr-2 text-secondary" data-id="element-169" data-mp="e695527a3974">●</span>
                {point}
              </motion.p>)}
          </div>

          <div className="text-center mt-12 pt-8 border-t border-primary/10" data-id="element-170" data-mp="5747rz7gdlwj">
            <p className="text-2xl font-display font-bold text-primary" data-id="element-171" data-mp="5977xc2bkvez">
              Your Automotive Technology knowledge is already there.
            </p>
            <p className="text-2xl font-display font-bold text-primary mt-2" data-id="element-172" data-mp="3rnqlj6jh06ke">
              What you need is a <span className="text-secondary" data-id="element-173" data-mp="3mox9zjnqupmv">system</span> that helps you turn
              that knowledge into structured, visual and ready-to-teach lessons faster.
            </p>
            <p className="text-xl mt-4 text-secondary font-semibold" data-id="element-174" data-mp="3dmxn4aq1src0">
              Solve Months of Automotive Lesson Planning in Just 5 MINUTES
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}